import React from "react";
import { Input } from "rsuite";
import { handleDecimalKeyDown, limitDecimalPlaces, roundToTwoDecimals } from "utils/utils";

const DEFAULT_FEE_REGEX = /^(10(\.0{0,2})?|[1-9](\.\d{0,2})?)$/;

/**
 * Reusable input for decimal fields with max decimal limitation,
 * key-down character blocking, optional regex filtering, and rounding on blur.
 */
const DecimalInput = ({
  value,
  onChange,
  onBlur,
  maxDecimals = 2,
  regex = DEFAULT_FEE_REGEX,
  validateChange,
  roundOnBlur = true,
  type = "number",
  step = "1",
  ...restProps
}) => {
  const handleChange = (rawVal) => {
    if (rawVal === "") {
      onChange?.("");
      return;
    }
    const valToSet = limitDecimalPlaces(rawVal, maxDecimals);
    if ((!regex || regex.test(valToSet)) && (!validateChange || validateChange(valToSet))) {
      onChange?.(valToSet);
    }
  };

  const handleBlur = (e) => {
    onBlur?.(e);
    if (roundOnBlur && value !== "" && value !== undefined && value !== null) {
      const rounded = roundToTwoDecimals(value);
      if (value !== rounded) {
        onChange?.(rounded);
      }
    }
  };

  return (
    <Input
      type={type}
      step={step}
      value={value ?? ""}
      onKeyDown={(e) => handleDecimalKeyDown(e, value, maxDecimals)}
      onChange={handleChange}
      onBlur={handleBlur}
      {...restProps}
    />
  );
};

export default DecimalInput;

